<span class="pill rounded-pill">
    <ng-content></ng-content>
</span>